<template>
  <div class="headers">
    <div class="top_list">
      <div class="nav_can">
        <h4>
          <img @click="goList()" src="@/assets/image/logo.png" />
          hello，欢迎使用采编名片.
        </h4>
        <div class="nav_right" v-if="!token">
          <span @click="logList">登录</span>
          <span @click="resgis">注册</span>
        </div>
        <div class="nav_right" v-else>
          <div>
            <span @click="liveData" style="cursor: pointer">
              你好，{{ userInfo.name ? userInfo.name : userInfo.account }}</span>
            <span style="margin-left: 20px" @click="liveTop">
              <img class="imgsrc" style="margin-right: 5px" src="@/assets/image/msg.png" />消息</span>
            <span style="margin-left: 0px" @click="goUserCenter">
              <img class="imgsrc" style="margin-right: 2px; width: 25px; height: 22px" src="@/assets/image/cardcase.png" />
              名片夹</span>
          </div>
          <!--
          <Dropdown>
            <span> {{ userInfo.account }} </span>
            <DropdownMenu slot="list">
              <DropdownItem @click.native="goUserCenter"
                ><span>名片夹</span></DropdownItem
              >
              <DropdownItem @click.native="logOut"><span>退出</span></DropdownItem>
            </DropdownMenu>
          </Dropdown>
          -->
        </div>
      </div>
    </div>
    <register :topgit="topgit" @topgitnew="havar"></register>
    <login :dllogin="dllogin" @livets="dealgata"></login>
  </div>
</template>
<script>
import register from "@/components/register";
import login from "@/components/login";
export default {
  name: "headers",
  components: {
    register,
    login,
  },
  data() {
    return {
      topgit: false,
      dllogin: false,
      token: "",
      githave: "",
      userInfo: [],
    };
  },
  created() {
    if (this.$route.query.user) {
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userInfo");
      this.$router.push({
        path: "/",
        query: {
          editId: this.$route.query.editId,
          perId: this.$route.query.perId,
        },
      });
    }
    this.tripSet();
  },
  mounted() {
    this.githave = window.sessionStorage.getItem("githave");
    var liscity = sessionStorage.getItem("liscity");
    if (liscity) {
      this.dllogin = liscity;
    }
  },
  watch: {
    dllogin(vale) {
      this.dllogin = vale;
    },
    topgit: {
      handler(item) {
        this.topgit = item;
        // this.$nextTick(function () {
        //   this.cancel();
        // });
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  methods: {
    git_userid() {
      this.$apis.manage.getUserInfo().then((res) => {
        if (res.resultCode == "200") {
          this.userIds = res.content.detail.userInfo.userId;
          this.names = res.content.detail.userInfo.mobile;
        }
      });
    },
    dealgata(lisves) {
      window.sessionStorage.removeItem("liscity");
      this.dllogin = lisves;
    },
    havar(topgit) {
      window.sessionStorage.removeItem("liscity");
      this.topgit = topgit;
      this.dllogin = false;
    },
    goList() {
      var editId = this.$store.state.cbianId;
      var perId = this.$store.state.qikanId;
      this.$router.push({
        path: "/",
        query: {
          editId: editId,
          perId: perId,
        },
      });
      setTimeout(() => {
        this.$router.go(0);
      }, 500);
    },
    goUserCenter() {
      // if (this.$route.path == "/cardHolder") {
      //   this.$router.push({
      //     path: "/cardHolder",
      //     query: {
      //       editId: this.$store.state.cbianId,
      //       perId: this.$store.state.qikanId,
      //       perName: 0,
      //     },
      //   });
      //   this.$router.go(0);
      // } else {
      //   this.$router.push({
      //     path: "/cardHolder",
      //     query: {
      //       editId: this.$store.state.cbianId,
      //       perId: this.$store.state.qikanId,
      //     },
      //   });
      // }
      var token = window.sessionStorage.getItem("token", token);
      var urlList = "";
      if (token) {
        this.$apis.manage.getUserInfo().then((res) => {
          if (res.resultCode == 200) {
            if (
              location.host.indexOf("cbtest.") != -1 ||
              location.host.indexOf("127.") != -1 ||
              location.host.indexOf("localhost") != -1
            ) {
              urlList = "https://dev1.cnknowledge.com/newtsgweb/?token="; //
            } else if (location.host.indexOf("yucard") != -1) {
              urlList = "https://yutsg.cnknowledge.com/newtsgweb?token="; //
            } else {
              urlList = "https://publish.cnknowledge.com/newtsgweb?token="; //
            }
            var mywin = window.open(`${urlList}&editId=${this.$store.state.cbianId}#/manage/nameCard`);
            mywin.location.reload(true);
          }
        });
      } else {
        this.$root.Bus.$emit("analy", true);
        // this.$Message.error("请登录您的用户");
      }
    },
    liveData() {
      var token = window.sessionStorage.getItem("token", token);
      var urlList = "";
      if (token) {
        this.$apis.manage.getUserInfo().then((res) => {
          if (res.resultCode == 200) {
            if (
              location.host.indexOf("cbtest.") != -1 ||
              location.host.indexOf("127.") != -1 ||
              location.host.indexOf("localhost") != -1
            ) {
              urlList = "https://1.com/newtsgweb/?token="; //
            } else if (location.host.indexOf("yucard") != -1) {
              urlList = "https://yutsg.cnknowledge.com/newtsgweb?token="; //
            } else {
              urlList = "https://publish.cnknowledge.com/newtsgweb?token="; //
            }
            var mywin = window.open(`${urlList}&editId=${this.$store.state.cbianId}&prid=${this.$store.state.qikanId}#/manage/author`);
            mywin.location.reload(true);
          }
        });
      } else {
        this.$root.Bus.$emit("analy", true);
        // this.$Message.error("请登录您的用户");
      }
      // if (token) {
      //   if (this.$route.path == "/cardHolder") {
      //     this.$router.push({
      //       path: "/cardHolder",
      //       query: {
      //         editId: this.$store.state.cbianId,
      //         perId: this.$store.state.qikanId,
      //         perName: 4,
      //       },
      //     });
      //     this.$router.go(0);
      //   } else {
      //     this.$router.push({
      //       path: "/cardHolder",
      //       query: {
      //         perName: 4,
      //         editId: this.$store.state.cbianId,
      //         perId: this.$store.state.qikanId,
      //       },
      //     });
      //   }
      // } else {
      //   this.$root.Bus.$emit("analy", true);
      //   this.$Message.success("请登录您的用户");
      // }
      // this.$router.push({ path: "/messageList" });
    },
    async getUserInfo() {
      const res = await this.$apis.manage.tokenGetUserInfo();
      if (res.resultCode === '200') {
        this.userInfo = res.content;
        window.sessionStorage.setItem("userInfo", JSON.stringify(res.content));
      }
    },
    tripSet() {
      return new Promise((resolve, reject) => {
        this.$apis.manage
          .getPk()
          .then((res) => {
            window.sessionStorage.setItem("trip", res.pk);
            if (res.token) {
              sessionStorage.setItem("token", res.token);
              this.token = res.token;
              this.getUserInfo()
            } else {
              sessionStorage.removeItem("token");
              sessionStorage.removeItem("userInfo");
            }
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    //退出
    logOut() {
      this.$apis.manage.logOut().then((res) => {
        if (res.resultCode == "200") {
          this.$Message.success("退出成功!");
          sessionStorage.removeItem("token");
          window.location.href =
            window.location.protocol +
            "//" +
            window.location.host +
            "/" +
            window.location.search;
          // this.$router.push({
          //   path: "/",
          //   query: {
          //     editId: this.$store.state.cbianId,
          //     perId: this.$store.state.qikanId,
          //   },
          // });
        } else {
          this.$Message.error(res.resultDesc);
        }
      });
    },
    resgis() {
      this.topgit = true;
      this.$store.state.linkName = "";
    },
    logList() {
      localStorage.setItem("dllogin", true);
      this.dllogin = true;
      this.$store.state.linkName = "";
    },

    liveTop() {
      // var token = this.$store.state.token;
      // if (token) {
      //   if (this.$route.path == "/cardHolder") {
      //     this.$router.push({
      //       path: "/cardHolder",
      //       query: {
      //         editId: this.$store.state.cbianId,
      //         perId: this.$store.state.qikanId,
      //         perName: 2,
      //       },
      //     });
      //     this.$router.go(0);
      //   } else {
      //     this.$router.push({
      //       path: "/cardHolder",
      //       query: {
      //         perName: 2,
      //         editId: this.$store.state.cbianId,
      //         perId: this.$store.state.qikanId,
      //       },
      //     });
      //   }
      // } else {
      //   this.$root.Bus.$emit("analy", true);
      //   this.$Message.success("请登录您的用户");
      // }
      // this.$router.push({ path: "/messageList" });
      var token = window.sessionStorage.getItem("token", token);
      var urlList = "";
      if (token) {
        this.$apis.manage.getUserInfo().then((res) => {
          if (res.resultCode == 200) {
            if (
              location.host.indexOf("cbtest.") != -1 ||
              location.host.indexOf("127.") != -1 ||
              location.host.indexOf("localhost") != -1
            ) {
              urlList = "https://1.com/newtsgweb/?token="; //
            } else if (location.host.indexOf("yucard") != -1) {
              urlList = "https://yutsg.cnknowledge.com/newtsgweb?token="; //
            } else {
              urlList = "https://publish.cnknowledge.com/newtsgweb?token="; //
            }
            var mywin = window.open(
              `${urlList}&editId=${this.$store.state.cbianId}&prid=${this.$store.state.qikanId}#/manage/inquiryService`
            );
            mywin.location.reload(true);
          }
        });
      } else {
        this.$root.Bus.$emit("analy", true);
        // this.$Message.error("请登录您的用户");
      }
    },
  },
};
</script>
<style scoped>
.top_list {
  width: 100%;
  background: #132466;
}

.nav_can {
  width: 1200px;
  margin: 0 auto;
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
}

.nav_can h4 {
  cursor: pointer;
}

.nav_can h4 img {
  width: 40px;
  height: 30px;
  vertical-align: middle;
  margin-right: 10px;
}

.nav_right {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}

.nav_right span {
  margin-right: 20px;
  cursor: pointer;
}

.imgsrc {
  width: 21px;
  height: 21px;
  vertical-align: middle;
  margin-right: 25px;
}
</style>
